import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import s from './Account.module.css';
import {Link} from "react-router-dom";

const Success = () => {
    return (
        <div className={s.successRegistration}>
            <h3>Ваша учетная запись создана!</h3>
            <p>Поздравляем! Ваш Личный Кабинет был успешно создан.</p>
            <p>Теперь вы можете воспользоваться дополнительными возможностями: просмотр истории заказов, печать счета,
                изменение своей контактной информации и адресов доставки и многое другое.
            </p>
            <BuyButton><Link to="/account/login">ПРОДОЛЖИТЬ</Link></BuyButton>
        </div>
    )
}

export default Success;